import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FreudMenuModule } from '@freud-ds/web-components';
import { UserToggleStatusModule } from 'modules/user/components/user-toggle-status/user-toggle-status.module';

import { HeaderSubmenuComponent } from './header-submenu.component';

@NgModule({
	declarations: [HeaderSubmenuComponent],
	imports: [CommonModule, FreudMenuModule, UserToggleStatusModule],
	exports: [HeaderSubmenuComponent],
	providers: [],
})
export class HeaderSubmenuModule {}
